import BaseEnumType from "../../common/base-enum-type";

const GameType = Object.freeze({
    SingleSet: { ...new BaseEnumType("1", "Single Set"), value: 1 },
    BestOf3: { ...new BaseEnumType("3", "Best of 3"), value: 3 },
    BestOf5: { ...new BaseEnumType("5", "Best of 5"), value: 5 },
    BestOf7: { ...new BaseEnumType("7", "Best of 7"), value: 7 },
    UpTo2: { ...new BaseEnumType("UT2", "Up to 2"), value: 2 },
    UpTo3: { ...new BaseEnumType("UT3", "Up to 3"), value: 3 },
    UpTo4: { ...new BaseEnumType("UT4", "Up to 4"), value: 4 },
    UpTo5: { ...new BaseEnumType("UT5", "Up to 5"), value: 5 },
    UpTo6: { ...new BaseEnumType("UT6", "Up to 6"), value: 6 },
    UpTo7: { ...new BaseEnumType("UT7", "Up to 7"), value: 7 }
});

export const isUpTo = (code) => {
    return [
        GameType.UpTo2,
        GameType.UpTo3,
        GameType.UpTo4,
        GameType.UpTo5,
        GameType.UpTo6,
        GameType.UpTo7
    ].some((t) => t.code === code);
};

export default GameType;
